import type { AppTab, AppTabId } from "../lib/navigation";

interface BottomNavigationProps {
  tabs: readonly AppTab[];
  activeTab: AppTabId;
  onTabChange: (tab: AppTabId) => void;
}

export function BottomNavigation({ tabs, activeTab, onTabChange }: BottomNavigationProps) {
  return (
    <nav className="bottom-nav" aria-label="Navegação principal">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const active = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            className={`bottom-nav__item ${active ? "bottom-nav__item--active" : ""}`.trim()}
            aria-current={active ? "page" : undefined}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="bottom-nav__icon">
              <Icon size={21} strokeWidth={active ? 2.4 : 1.9} aria-hidden="true" />
            </span>
            <span className="bottom-nav__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
